import { render } from "./AdditionalInformation.vue?vue&type=template&id=75205edf&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"

import "./AdditionalInformation.vue?vue&type=style&index=0&id=75205edf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75205edf"]])

export default __exports__